"use client";
import React from "react";
import { generateTokenUrl } from '@/utils/tokenUrls';

interface WebPageSchemaMarkupProps {
  t: any;
  ti: any;
  symbol?: string;
}

export default function WebPageSchemaMarkup({ t, ti, symbol }: WebPageSchemaMarkupProps) {
  // Helper to generate absolute token URL
  function getAbsoluteTokenUrl(token: any) {
    return `https://www.solflare.com${generateTokenUrl(token)}`;
  }

  // Helper functions for safe property access
  const display = (val: unknown): string =>
    val === undefined || val === null || val === '' ? 'MISSING' : String(val);

  const safe = (obj: unknown, key: string): string => {
    if (obj && typeof obj === 'object' && key in obj) {
      const val = (obj as Record<string, unknown>)[key];
      return display(val);
    }
    return 'MISSING';
  };

  // Generate page title
  const pageTitle = `${display(t.name)}${symbol ? ` (${symbol})` : ''} Price | Solflare`;

  // Generate page description
  const pageDescription = `Live ${display(t.name)}${symbol ? ` (${symbol})` : ''} price data, market cap, volume, and real-time chart. Stay updated with the latest ${display(t.name)} token performance on Solflare.`;

  // Get current timestamp for dateModified
  const currentDate = new Date().toISOString();

  // Use a fixed date for datePublished (could be set to when the page was first created)
  const publishedDate = "2025-07-05T12:00:00Z";

  return (
    <script
      type="application/ld+json"
      suppressHydrationWarning
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: pageTitle,
          url: getAbsoluteTokenUrl(t),
          description: pageDescription,
          datePublished: publishedDate,
          dateModified: currentDate,
          inLanguage: 'en',
          isPartOf: {
            '@type': 'WebSite',
            name: 'Solflare',
            url: 'https://www.solflare.com'
          },
          mainEntity: {
            '@type': 'Thing',
            name: display(t.name),
            url: 'https://www.solflare.com/prices'
          }
        })
      }}
    />
  );
} 